import React from 'react'
import { TextField } from 'material-ui'
import omit from 'lodash/omit'

const FormInput = ({
  value,
  onChange,
  label,
  placeholder,
  style,
  disabled,
  rows = 1,
  multiLine = false,
  rowsMax = 1,
  className = '',
  ...props
}) => (
  <TextField
    className={className}
    fullWidth
    hintText={placeholder}
    floatingLabelText={label}
    value={value}
    onChange={(event, newValue) => onChange(newValue)}
    style={style}
    disabled={disabled}
    underlineDisabledStyle={{ display: 'none' }}
    multiLine={multiLine}
    rows={rows}
    rowsMax={rowsMax}
    {...omit(props, ['tabLabel', 'tabValue', 'showButton'])}
  />
)

FormInput.propTypes = {}
FormInput.defaultProps = {}

export default FormInput



// WEBPACK FOOTER //
// ./src/components/forms/bases/FormInput.js